import { AppState } from './../../../../core/reducers/index';
import { Observable } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserAddressService } from './../../../../api/userAddress.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { currentUser, User } from '@app/core/auth';
import { select, Store } from '@ngrx/store';
import * as address from 'assets/json/address.json';
import * as addressNew from 'assets/json/new-address.json';
@Component({
  selector: 'meu-app-edit-address',
  templateUrl: './app-edit-address.component.html',
  styleUrls: ['./app-edit-address.component.scss'],
})
export class AppEditAddressComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private userAddressService: UserAddressService,
    private store: Store<AppState>,
    private ref: ChangeDetectorRef
  ) {}

  addressID: any;
  addressForm = new FormGroup({
    fullname: new FormControl('', [Validators.required]),
    province: new FormControl('', [Validators.required]),
    district: new FormControl('', [Validators.required]),
    ward: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    address: new FormControl('', [Validators.required, Validators.maxLength(100)]),
    is_company: new FormControl('', [Validators.required]),
    is_default: new FormControl(false),
    user_id: new FormControl('', [Validators.required]),
    country: new FormControl('', [Validators.required]),
  });
  lstDistrict: any = [];
  lstAddress: any = [];
  lstWard: any = [];
  lstAddressJson: any = [];
  lstAddressJsonOld: any = [];
  lstAddressJsonNew: any = [];
  lstProvince: any = [];
  user$: Observable<User>;
  myInfo: any;
  hasFormErrors: boolean = false;
  addressVersion: 'old' | 'new' = 'old';

  ngOnInit() {
    this.lstAddressJsonOld = Object.values(JSON.parse(JSON.stringify(address.default)));
    this.lstAddressJsonNew = Object.values(JSON.parse(JSON.stringify(addressNew.default)));
    this.initAddressData();
    this.user$ = this.store.pipe(select(currentUser));
    this.user$.subscribe((user) => {
      this.myInfo = user;
    });
    if (this.activatedRoute.snapshot.params.id != undefined) {
      this.addressID = this.activatedRoute.snapshot.params.id;
      this.getAddressByID();
    }
  }

  private initAddressData() {
    this.lstAddressJson = this.addressVersion === 'new' ? this.lstAddressJsonNew : this.lstAddressJsonOld;
    this.lstProvince = this.lstAddressJson.map((x) => this.addressVersion === 'new' ? x.Name : x.name).slice();
  }

  detectVersionByProvince(provinceName: string): 'old' | 'new' {
    const foundOld = this.lstAddressJsonOld.find((x) => x.name === provinceName);
    if (foundOld) return 'old';
    const foundNew = this.lstAddressJsonNew.find((x) => x.Name === provinceName || x.FullName === provinceName);
    if (foundNew) return 'new';
    return 'old';
  }
  getAddressByID() {
    this.userAddressService.apiUserAddressesIdGet(this.addressID).subscribe((res) => {
      if (res.success) {
        this.addressVersion = this.detectVersionByProvince(res.data.province);
        this.initAddressData();
        this.addressForm.patchValue({
          fullname: res.data.fullname,
          province: res.data.province,
          phone: res.data.phone,
          address: res.data.address,
          is_company: res.data.is_company,
          is_default: res.data.is_default,
          user_id: res.data.user_id,
        });

        if (this.addressVersion === 'new') {
          const prov = this.lstAddressJsonNew.find((x) => x.Name === res.data.province || x.FullName === res.data.province);
          if (prov && prov.Wards) {
            this.lstDistrict = [{ name: res.data.province, wards: prov.Wards }];
            this.addressForm.patchValue({ district: res.data.province });
            this.lstWard = Object.values(JSON.parse(JSON.stringify(prov.Wards)));
            this.addressForm.patchValue({ ward: res.data.ward });
          }
        } else {
          this.lstDistrict = Object.values(
            JSON.parse(
              JSON.stringify(
                this.lstAddressJson.find((x) => x.name == this.addressForm.value.province).districts
              )
            )
          );
          this.addressForm.patchValue({
            district: res.data.district,
          });
          this.lstWard = Object.values(
            JSON.parse(
              JSON.stringify(
                this.lstDistrict.find((x) => x.name == this.addressForm.value.district).wards
              )
            )
          );
          this.addressForm.patchValue({
            ward: res.data.ward,
          });
        }
        this.ref.detectChanges();
      }
    });
  }
  updateLstDistrict() {
    this.addressForm.patchValue({
      district: '',
    });
    if (this.addressVersion === 'new') {
      const prov = this.lstAddressJsonNew.find((x) => x.Name === this.addressForm.value.province || x.FullName === this.addressForm.value.province);
      if (prov && prov.Wards) {
        this.lstDistrict = [{ name: this.addressForm.value.province, wards: prov.Wards }];
        this.addressForm.patchValue({ district: this.addressForm.value.province });
        this.lstWard = Object.values(JSON.parse(JSON.stringify(prov.Wards)));
        this.addressForm.patchValue({ ward: '' });
      }
      return;
    }
    this.lstDistrict = Object.values(
      JSON.parse(
        JSON.stringify(
          this.lstAddressJson.find((x) => x.name == this.addressForm.value.province).districts
        )
      )
    );
  }
  updateListWard() {
    this.addressForm.patchValue({
      ward: '',
    });
    if (this.addressVersion === 'new') {
      const prov = this.lstAddressJsonNew.find((x) => x.Name === this.addressForm.value.province || x.FullName === this.addressForm.value.province);
      if (prov && prov.Wards) {
        this.lstWard = Object.values(JSON.parse(JSON.stringify(prov.Wards)));
      }
      return;
    }
    this.lstWard = Object.values(
      JSON.parse(
        JSON.stringify(
          this.lstDistrict.find((x) => x.name == this.addressForm.value.district).wards
        )
      )
    );
  }
  createMyNewAddress() {
    this.addressForm.patchValue({
      user_id: this.myInfo ? this.myInfo.id : '',
      country: 'Việt Nam',
    });
    const controls = this.addressForm.controls;
    if (this.addressForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    } else {
      this.userAddressService.apiUserAddressesPost(this.addressForm.value).subscribe((res) => {
        if (res.success) {
          window.history.back();
        }
      });
    }
  }
  updateMyAddress() {
    this.addressForm.patchValue({
      user_id: this.myInfo ? this.myInfo.id : this.addressForm.value.user_id,
      country: 'Việt Nam',
    });
    const controls = this.addressForm.controls;
    if (this.addressForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      return;
    } else {
      this.userAddressService
        .apiUserAddressesIdPut(this.addressID, this.addressForm.value)
        .subscribe((res) => {
          if (res.success) {
            window.history.back();
          }
        });
    }
  }
}
